module.exports = __webpack_public_path__ + "catalog/holes/venetian-blind-window/venetian.jpg";